import { createStore, applyMiddleware, compose } from 'redux'
import ReduxThunk from 'redux-thunk'
import rootReducer from 'reducers'
import { autoRehydrate, persistStore as _persistStore } from 'redux-persist'
import localForage from 'localforage'

const storage = localForage

const middlewares = [ReduxThunk]

export default function configureStore(initialState = {}) {
  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middlewares), autoRehydrate({ storage }))
  )
}

export const persistStore = store =>
  new Promise((resolve, reject) => {
    _persistStore(
      store,
      {
        blacklist: ['dashboard', 'form', 'dialog'],
        storage,
      },
      () => resolve()
    )
  })



// WEBPACK FOOTER //
// ./src/store/store.prod.js